import React from "react";
import { BellOutlined } from "@ant-design/icons";
import ElsaAdaptiveEmblem from "../components/branding/ElsaAdaptiveEmblem";

const getGreeting = (date = new Date()) => {
  const hour = date.getHours();
  if (hour < 12) return "Bonjour";
  if (hour < 18) return "Bon apres-midi";
  return "Bonsoir";
};

const getInitials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

export default function MobileHomeHeader({
  userName = "",
  notifCount = 0,
  onBell,
  onAvatar,
  logoSrc,
  notificationSlot,
  rightSlot,
}) {
  return (
    <header className="ea-header">
      {logoSrc ? (
        <img className="ea-header__logo" src={logoSrc} alt="ELSA GESTION" />
      ) : (
        <ElsaAdaptiveEmblem className="ea-header__logo" />
      )}
      <div className="ea-header__greet">
        <small>{getGreeting()},</small>
        <b>{userName || "Bienvenue"}</b>
      </div>
      <div className="ea-header__actions">
        {rightSlot}
        {notificationSlot !== undefined ? notificationSlot : (
          <button
            type="button"
            className="ea-iconbtn"
            aria-label="Notifications"
            onClick={onBell}
          >
            <BellOutlined />
            {notifCount > 0 ? (
              <span className="ea-dot">{notifCount > 9 ? "9+" : notifCount}</span>
            ) : null}
          </button>
        )}
        <button
          type="button"
          className="ea-avatar"
          aria-label="Profil"
          onClick={onAvatar}
        >
          {getInitials(userName) || "EG"}
        </button>
      </div>
    </header>
  );
}
